<template>
  <div>
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("CRUD.editInfo", [$t("WaveSettings.ObjectName")]) }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("WaveRules.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("WaveSettings.Fields.default_order_count") +
                    $t("Global.colon")
                  }}
                  <Required show mode />
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('WaveSettings.Fields.default_order_count')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="waveSetting.wave_order_num"
                      :error-messages="errors"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("WaveSettings.Fields.pack_setting") + $t("Global.colon")
                  }}
                  <Required :show="true" mode />
                </v-col>
                <v-col cols="9" md="7">
                  <v-checkbox
                    v-model="waveSetting.pack_setting"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("WaveSettings.Fields.container_setting") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-checkbox
                    v-model="waveSetting.container_setting"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("WaveSettings.Fields.different_shop_disable") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-checkbox
                    v-model="waveSetting.different_shop_disable"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("WaveSettings.Fields.sorting_task_setting") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-checkbox
                    v-model="waveSetting.sorting_task"
                    disabled
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>

      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  :disabled="!stock_id"
                  @click="
                    $router.push('/stocks/wave-rulers?stock_id=' + stock_id)
                  "
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backToList", [$t("WaveRules.ObjectName")]) }}
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn
                  color="success"
                  block
                  :disabled="loading"
                  @click="submit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.saveInfo", [$t("WaveSettings.ObjectName")]) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import Breadcrumbs from "@/components/Breadcrumbs";
import Required from "@/components/plugins/Required";
import Stocks from "@/api/stocks";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    Required,
    Breadcrumbs,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stocks"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.strageticManagement"),
          disabled: false,
          href: "/stocks/wave-rulers?stock_id=" + this.stock_id,
        },
        {
          text:
            this.waveSetting && this.waveSetting.name
              ? this.waveSetting.name
              : "",
          accent: true,
          disabled: false,
        },
        {
          text: i18n.t("Nav.waveSettings"),
          disabled: true,
          href: "/stocks/wave-settings?stock_id=" + this.stock_id,
        },
      ];
    },

    stock_id() {
      return this.$route.query.stock_id ? this.$route.query.stock_id : 0;
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  mounted() {
    if (this.$route.query.stock_id) {
      this.getWaveSettingFromAPI();
    }
  },

  data: () => ({
    waveSetting: {},
  }),

  methods: {
    getWaveSettingFromAPI() {
      Stocks.fetchOne(this.$route.query.stock_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.waveSetting = response.data.stock;
          }
        }.bind(this)
      );
    },
    submit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            Stocks.save(this.$route.query.stock_id, this.waveSetting)
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.getWaveSettingFromAPI();
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
  },
};
</script>